module.exports = __webpack_public_path__ + "img/bash.a8a8af6f.png";